<template>
  <div v-if="notifications.length > 0">
    <v-snackbar
      v-for="notification in notifications"
      :key="notification.id"
      v-model="notification.show"
      transition="slide-y-transition"
      :color="notification.color"
      :timeout="notification.timeout">
      <span v-html="notification.content"/>
      <template #action>
        <v-icon @click="notification.show = false">mdi-close-circle</v-icon>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
/**
 * This component displays all temporary notifications that disappear after a period of time. Could be success
 * notifications, or the like.
 */
export default {
  name: 'AppNotifications',
  computed: {
    notifications () {
      return this.$store.getters['globalMessagingModule/getNotifications']
    }
  }
}
</script>
